import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  user_id: sessionStorage.getItem('userId')||localStorage.getItem('user_id'),
  nickname: sessionStorage.getItem('nickname')||localStorage.getItem('nickname'),
  username: sessionStorage.getItem('username')||localStorage.getItem('username'),
  avatar: sessionStorage.getItem('avatar')||localStorage.getItem('avatar'),
  item_content:null
}

const mutations = {
  //设置用户id
  SET_USER_ID: (State, data) => {
    State.user_id = data
    localStorage.setItem('user_id',data)
    sessionStorage.user_id = data
  },
  //设置用户信息
  SET_USER_INFO: (State, data) => {
    State.username = data.username
    State.nickname = data.nickname
    State.avatar = data.avatar
    localStorage.setItem('nickname',data.nickname)
    localStorage.setItem('username',data.username)
    localStorage.setItem('avatar',data.avatar)
    sessionStorage.nickname = data.nickname;
    sessionStorage.username = data.username;
    sessionStorage.avatar =  data.avatar;
  },
  SET_ITEM_CONTENT:(State,data)=>{
    State.item_content=data
  }
}
//inkdoc
const actions = {};
export default new Vuex.Store({
  state,
  mutations,
  actions,
})
